export default {
  'status': {
    display: {
        name: '處理狀態',
        type: 'string',
    },
    source: {
        type: 'db',
        key: 'status',
        data_type: 'string',
    },
    change: {
        editable: true,
        addable: true,
        type: 'single-select-as-is',
        options: {
            type: 'fixed',
            list: ['已處理','未處理','處理中'].map(x=>({value:x, label:x}))
        }
    }
  },
  'type': {
      display: {
          name: '問題類型',
          type: 'string',
      },
      source: {
          type: 'db',
          key: 'type',
          data_type: 'string',
      },
      change: {
          editable: false,
          addable: false,
      }
  },
  'username': {
      display: {
          name: '回報者',
          type: 'string',
      },
      source: {
          type: 'db',
          key: 'username',
          data_type: 'string',
      },
      change: {
          editable: false,
          addable: false,
      }
  },
  'created_time': {
    display: {
        name: '回報時間',
        type: 'string',
    },
    source: {
        type: 'db',
        key: 'created_time',
        data_type: 'datetime',
    },
    change: {
        editable: false,
        addable: false,
      }
  },
  'screenshot_url': {
    display: {
      name: '縮圖',
      type: 'image',
      //width: '100px',
    },
    source: {
      type: 'db',
      key: 'screenshot_url',
      data_type: 'string',
    },
    change: {
      editable: false,
      addable: false,
    }
  },
  'content': {
    display: {
        name: '回報內容',
        type: 'multi-line-string',
    },
    source: {
        type: 'db',
        key: 'content',
        data_type: 'string',
    },
    change: {
        editable: false,
        addable: false,
      }
  },
  'reply_content': {
    display: {
        name: '回覆',
        type: 'string',
    },
    source: {
        type: 'db',
        key: 'reply_content',
        data_type: 'string',
    },
    change: {
        editable: true,
        addable: false,
        type: 'multi-line-string',
      }
  },
}